<template>
  <div>
    <div v-if="selectedTemplate">
      <v-banner class="banner-without-padding py-1" style="top:50px; z-index:1" sticky color="primary" single-line>
        <v-layout wrap>
          <v-flex xs12 class="primary white--text" text-center>
            <h3>
              <span>{{ $t('a') }}</span>
              <v-icon small class="ml-2 primary--text">mdi-pen</v-icon>
            </h3>
          </v-flex>
        </v-layout>
      </v-banner>
      <v-layout wrap>
        <v-flex xs12>
          <v-layout wrap>
            <v-flex xs3 class="leftCell" pl-1>{{ $t('a1') }}</v-flex>
            <v-flex xs9 pl-2>
              <v-layout wrap>
                <v-flex xs6>
                  {{ selectedTemplate.name }}
                </v-flex>
                <v-flex xs6 text-end pr-2>
                  <v-btn v-if="companyTemplates.length > 0" @click="isShowingChangeTemplateDialog = true" x-small outlined>
                    <v-icon x-small class="mr-2">mdi-pen</v-icon>
                    {{ $t('b') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-divider/>

          <v-layout wrap>
            <v-flex xs3 class="leftCell" pl-1>{{ $t('c') }}</v-flex>
            <v-flex xs9 pl-2>
              <v-layout wrap>
                <v-flex xs6>
                  {{ getLanguageName(selectedTemplate.language) }}
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          
          <v-divider/>

          <v-layout wrap>
            <v-flex xs3 class="leftCell" pl-1>{{ $t('d') }}</v-flex>
            <v-flex xs9 pl-2>
              <v-layout wrap>
                <v-flex xs4>
                  {{ getLanguageName(dossier.profile.cvLanguage) }}
                </v-flex>
                <v-flex xs8 text-end pr-2>
                  <v-btn v-if="selectedTemplate && dossier.profile.cvLanguage !== selectedTemplate.language" @click="isShowingTranslateDialog = true" x-small outlined>
                    <v-icon x-small class="mr-2">mdi-translate</v-icon>
                    {{ $t('trad1') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-dialog v-model="isShowingTranslateDialog" v-if="!isTranslating" width="60%">
        <v-card class="px-12 pb-6 pt-6">
          <v-layout wrap>
            <v-flex xs12>
              <h3 class="text-center mb-6">{{ $t('trad2') }}</h3>
              <small>
                <div>{{ $t('trad3') }} <b>{{ getLanguageName(selectedTemplate.language) }}</b></div>
                <div>{{ $t('trad4') }}</div>
                <div class="mt-5 text-center"><b>{{ $t('trad5') }} {{ getLanguageName(selectedTemplate.language) }} ?</b></div>
              </small>
            </v-flex>
          </v-layout>
          <v-layout wrap pt-3>
            <v-flex xs6 text-end pr-12>
              <v-btn @click="translateToLanguageOfTemplate" class="primary">
                {{ $t('trad6') }}
              </v-btn>
            </v-flex>
            <v-flex xs6 pl-12>
              <v-btn @click="isShowingTranslateDialog = false" outlined>
                {{ $t('trad7') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>

      <v-dialog v-model="isTranslating" width="40%" persistent content-class="vDialogWithoutShadow">
        <v-layout wrap mb-6>
          <v-flex xs12 text-center>
            <v-avatar :size="225" color="primary">
              <img :src="images.translation">
            </v-avatar>
          </v-flex>
        </v-layout>
        <v-card class="px-6 pb-4 pt-4 text-center primary white--text">
          <div><b>{{ $t('trad8') }}</b></div>
          <v-progress-linear indeterminate color="secondary" class="mt-3"></v-progress-linear>
        </v-card>
      </v-dialog>


      <v-dialog v-model="isShowingChangeTemplateDialog" width="60%">
        <v-card class="px-12 pb-6 pt-6">
          <v-layout wrap>
            <v-flex xs12>
              <h3 class="text-center mb-6">{{ $t('e') }}</h3>
              <small>
                <v-select
                  v-model="templateId"
                  :items="companyTemplates"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  class="mt-3"
                  background-color="white"
                  hide-details
                ></v-select>
                <div class="mt-2">{{ $t('f') }}<b>{{ getLanguageName(selectedTemplate.language) }}</b></div>
              </small>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from "vuex";

const functionsUrlBase = {
  'localhost': 'http://localhost:5001/esnwebservices-dev/us-central1',
  'esnwebservices-dev.firebaseapp.com': 'https://europe-west1-esnwebservices-dev.cloudfunctions.net',
  'esnwebservices-prod.firebaseapp.com': 'https://europe-west1-esnwebservices-prod.cloudfunctions.net',
  'esnwebservices.com': 'https://europe-west1-esnwebservices-prod.cloudfunctions.net'
}[window.location.hostname]

export default {
  props: {
    dossier: Object,
    isConsultant: Boolean,
    isFromToken: Boolean
  },
  data: () => ({
    isShowingTranslateDialog: false,
    isShowingChangeTemplateDialog: false,
    isTranslating: false,
    companyTemplates: null,
    templateId: null,
    images: {
      translation: require('@/assets/app/images/3D_Model_Flatline.svg'),
    },
  }),
  computed: {
    ...mapGetters({
      user: "user"
    }),
    selectedTemplate() {
      if (!this.companyTemplates) return null; 
      return this.companyTemplates.find(template => template.id === this.templateId)
    }
  },
  async mounted() {
    this.companyTemplates = await this.getCompanyTemplates()
    this.templateId = this.companyTemplates.find(template => template.id === this.dossier.templateId) ? this.dossier.templateId : this.companyTemplates[0].id
  },
  methods: {
    async getCompanyTemplates() {
      if (this.isFromToken) {
        const response = await axios.get(`${functionsUrlBase}/getCompanyTemplatesFromToken?dossierId=${this.dossier.id}&accessToken=${this.$route.query.accessToken}`)
        return response.data.templates
      }
      else if (!this.isConsultant) return this.user.company.templates
      else {
        const response = await this.$functions.httpsCallable('consultantGetCompanyTemplates')({
          dossierId: this.dossier.id
        })
        return response.data.templates
      }
    },
    getLanguageName(language) {
      return {
        'FR': this.$t('FR'),
        'EN': this.$t('EN'),
        'DE': this.$t('DE'),
        'ES': this.$t('ES'),
        'IT': this.$t('IT'),
        'PT': this.$t('PT'),
        'NL': this.$t('NL'),
        'RU': this.$t('RU'),
        'UNKNOWN': this.$t('UNKNOWN')
      }[language]
    },
    async translateToLanguageOfTemplate() {
      this.isTranslating = true
      if (this.isFromToken) {
        const url = `${functionsUrlBase}/updateProfileAndCreateDossierFromToken?dossierId=${this.dossier.id}&accessToken=${this.$route.query.accessToken}`
        await axios.post(url, {
          profile: this.dossier.profile,
          templateId: this.dossier.templateId,
          labelIds: this.dossier.labelIds,
          translateProfileToTemplateLanguage: true,
          isRequestMadeByConsultant: false
        })
      } else {
        // Update dossier data in db, translate, create .docx, reload page.
        await this.$functions.httpsCallable('updateProfileAndCreateDossier')({
          dossierId: this.dossier.id,
          profile: this.dossier.profile,
          templateId: this.dossier.templateId,
          translateProfileToTemplateLanguage: true,
          isRequestMadeByConsultant: false
        })
      }
      this.$router.go()
    },
  },
  watch: {
    templateId: {
      handler(val, oldVal) {
        if (oldVal !== null) {
          this.dossier.templateId = this.templateId
        }
      }
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Template",
    "a1": "Template",
    "b": "Changer le template",
    "c": "Langue du template",
    "d": "Langue du contenu",
    "e": "Choix du template",
    "f": "Langue du template : ",

    "FR": "Français",
    "EN": "Anglais",
    "DE": "Allemand",
    "ES": "Espagnol",
    "IT": "Italien",
    "PT": "Portugais",
    "NL": "Néerlandais",
    "RU": "Russe",
    "UNKNOWN": "Inconnu",

    "trad1": "Traduire le contenu du dossier",
    "trad2": "Traduction vers la langue du template",
    "trad3": "Langue du template :",
    "trad4": "Les données suivantes seront traduites et écrasées : titre, expériences professionnelles, formations et certifications.",
    "trad5": "Souhaitez-vous activer la traduction en",
    "trad6": "Traduire",
    "trad7": "Annuler",
    "trad8": "Traduction en cours..."

  },
  "en": {
    
    "a": "Template",
    "a1": "Template",
    "b": "Change template",
    "c": "Language of template",
    "d": "Langue of content",
    "e": "Choice of template",
    "f": "Language of template : ",

    "FR": "French",
    "EN": "English",
    "DE": "German",
    "ES": "Spanish",
    "IT": "Italian",
    "PT": "Portuguese",
    "NL": "Dutch",
    "RU": "Russian",
    "UNKNOWN": "Unknown",

    "trad1": "Translate the CV's content",
    "trad2": "Translate into the template's language",
    "trad3": "Template's language:",
    "trad4": "The following data will be translated and overwritten: title, professional experiences, diplomas and certifications.",
    "trad5": "Do you want to translate into",
    "trad6": "Translate",
    "trad7": "Cancel",
    "trad8": "Translating..."
  }
}
</i18n>